// extracted by mini-css-extract-plugin
module.exports = {"enrollYears":"styles_enrollYears__17c1B","label":"styles_label__1sayV","list":"styles_list__2rEd1","year":"styles_year__1-4Tj","active":"styles_active__z_Kwz"};